import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=08bd7779"
import script from "./InformationCard.vue?vue&type=script&lang=js"
export * from "./InformationCard.vue?vue&type=script&lang=js"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=08bd7779&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports